import React, { useRef, useEffect, useState } from 'react';
import QRCode from 'qrcode.react';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import { Button } from '@mui/material';

const QrCodeGenerator: React.FC<{ value: string }> = ({ value }) => {
  const qrCodeContainerRef = useRef<HTMLDivElement | null>(null);
  const [downloadReady, setDownloadReady] = useState(false);

  useEffect(() => {
    if (qrCodeContainerRef.current) {
      setDownloadReady(true);
    }
  }, []);

  const downloadQrCode = () => {
    const container = qrCodeContainerRef.current;

    if (container) {
      html2canvas(container)
        .then((canvas) => {
          canvas.toBlob((blob) => {
            if (blob) {
              saveAs(blob, 'qrcode.png');
            }
          });
        })
        .catch((error) => {
          console.error('Error generating QR code:', error);
        });
    }
  };

  return (
    <div>
      <div className='qrCode' ref={qrCodeContainerRef}>
        <QRCode value={value} width={200} height={200} renderAs="svg" />
      </div>
      {downloadReady && (
        <Button variant='contained' className='mx-4' id='btn-add' onClick={downloadQrCode}>Download QR Code</Button>
      )}
    </div>
  );
};

export default QrCodeGenerator;
